import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../_components/common/Header";
import "../_css/ReportHistory.css";
import "../_css/AIFeedback.css";
import FeatureCard from "../_components/UI/FeatureCard";
import { useDispatch } from "react-redux";
import { getStudentReport, downloadReport } from "../requests";
import { deleteAuthToken, notifyError } from "../utils/helper";
import { startLoader, stopLoader } from "../_store/reducers/loaderReducer";
import { formatDateLong, formatGrade } from "../_components/helper/formatters";

import html2pdf from "html2pdf.js";

const ReportHistoryDetails = () => {
  const { grade, subject, exam, file_name } = useParams();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalCount, setTotalCount] = useState(0);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [students, setStudents] = useState([]);
  const [name, setName] = useState("");
  const [stats, setStats] = useState({
    total : 0,
    avg : 0,
    high : 0,
    low : 0

  })

  // Download PDF
  const divRef = useRef(null);


  const handleDownload = async (grade, subject, exam) => {
    dispatch(startLoader());
    try {
      const res = await downloadReport({ grade, subject, exam, file_name });

      const file = new Blob([res.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);

      const a = document.createElement("a");
      a.href = url;
      a.download = `${grade}-${subject}-${exam}.pdf`; // 👈 filename
      document.body.appendChild(a);
      a.click();

      // cleanup
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      notifyError(error?.response?.data?.error || "Error downloading report");
    } finally {
      dispatch(stopLoader());
    }
  };
  const handleDownloadWord = async (grade, subject, exam) => {
    dispatch(startLoader());
    try {
      const res = await downloadReport({ grade, subject, exam, type: 1, file_name });
      const file = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
      const url = window.URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${grade}-${subject}-${exam}.docx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      notifyError(error?.response?.data?.error || "Error downloading report");
    } finally {
      dispatch(stopLoader());
    }
  };

  const handleDownloadExcel = async (grade, subject, exam) => {
    dispatch(startLoader());
    try {
      const res = await downloadReport({ grade, subject, exam, type: 2, file_name });
      const file = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${grade}-${subject}-${exam}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      notifyError(error?.response?.data?.error || "Error downloading excel");
    } finally {
      dispatch(stopLoader());
    }
  };




  const get_students = async (pageVal) => {
    dispatch(startLoader());
    try {
     
      const res = await getStudentReport({grade, subject, exam, file_name}, {page: pageVal, limit: limit, name: name});
      setTotalCount(res.data.totalCount);

      setStudents(res.data.data);
     

      const total_marks = res.data.data.reduce((acc, e)=> acc + Number(e.marks_obt), 0 );
      const avg = total_marks / res.data.data.length;

      let high = 0;
      let low = 100;

      for(let e of res.data.data){
        if(Number(e.marks_obt) > high){
          high = Number(e.marks_obt)
        }

         if(Number(e.marks_obt) < low){
          low = Number(e.marks_obt)
        }
      }

      setStats({total : res.data.data.length, avg : avg.toFixed(2) , high,low})





    } catch (error) {
      if (error?.response?.status == 403) {
        notifyError(
          error?.response?.data?.error || "Your session has expired. Please log in again."
        );
        deleteAuthToken();
        navigate("/login");
        return;
      }

      console.log(error);
      

      notifyError( error?.response?.data?.error || "Error fetching data");
    } finally {
      dispatch(stopLoader());
    }
  };



  useEffect(() => {
    setPage(1);
    get_students(1);

  }, [grade,subject,exam,name]);

  useEffect(() => {
    get_students(page);
  }, [page,limit]);



  return (
    <div className='page-main'>
      <Header name={["Report History", "Report History Details"]} />

      <div className="ai-fd-main " ref={divRef}>
        <div className="ai-fd-con">
          <div className="report-head">
            <div className="report-head-text">
              Grade {grade} &nbsp;&nbsp;<span className="my-dot"></span>
              &nbsp;&nbsp;{subject} &nbsp;&nbsp;<span className="my-dot"></span>
              &nbsp;&nbsp;{exam}
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
            <button className="my-btn" onClick={() => handleDownload(grade, subject, exam, file_name)} id='exclude-pdf'>Export PDF</button>
            <button className="my-btn" onClick={() => handleDownloadWord(grade, subject, exam, file_name)} id='exclude-pdf'>Export Word</button>
            <button className="my-btn" onClick={() => handleDownloadExcel(grade, subject, exam, file_name)} id='exclude-pdf'>Export Excel</button>
            </div>
            
          </div>

          <div className="class-card-con">
            <FeatureCard title="Total Students" desc={students.length} color="#F3F4F6" />
            <FeatureCard
              title="Average Marks"
              desc={stats.avg}
              subText="+1 vs Last Exam"
              color="#F3F4F6"
            />
            <FeatureCard
              title="Highest Marks"
              desc={stats.high}
              subText="+1 vs Last Exam"
              color="#F3F4F6"
            />
            <FeatureCard
              title="Lowest Marks"
              desc={stats.low}
              subText="+1 vs Last Exam"
              color="#F3F4F6"
            />
          </div>

          <div className="class-table-con" style={{ marginTop: "30px" }}>
            <div className="class-toggle-head-con">
              <div className="report-head-text" style={{ fontSize: "22px" }}>
                Student Wise breakdown
              </div>

              <input
                className="student-list-search"
                style={{ height: "32px" }}
                placeholder="Search name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                id='exclude-pdf'
              />
            </div>
            <div className="ai-fd-table">
              <div className="ai-fd-table-head">
                <div className="ai-fd-head-cell" style={{ width: "20%" }}>
                  Student Name
                </div>
                <div className="ai-fd-head-cell" style={{ width: "20%" }}>Score</div>
                <div className="ai-fd-head-cell" style={{ width: "20%" }}>Class</div>
                <div className="ai-fd-head-cell" style={{ width: "20%" }}>
                  Subject
                </div>
                <div className="ai-fd-head-cell" style={{ width: "20%" }}>
                  Uploaded On
                </div>
               
              </div>
              {students.length > 0 &&
                students.map((e, i) => (
                  <div key={i} className="ai-fd-table-row">
                    <div className="ai-fd-row-cell" style={{ width: "20%" }}>
                      {e.student_name}
                    </div>
                    <div className="ai-fd-row-cell" style={{ width: "20%" }}>{Number(e?.marks_obt)} / {Number(e.marks_total)} </div>
                    <div className="ai-fd-row-cell" style={{ width: "20%" }}>{formatGrade(e.grade)}</div>
                    <div className="ai-fd-row-cell" style={{ width: "20%" }}>
                      {e.subject}
                    </div>
                    <div className="ai-fd-row-cell" style={{ width: "20%" }}>
                      {formatDateLong(e.created_at)}
                    </div>
                    
                  </div>
                ))}
               
               
                
               
            </div>
            <div className="di-flex" style = {{width: '100%'}}>
          <div style={{ color: "#6B7280" }}>
            {" "}
            Showing {((page-1) * limit )+ 1} to {students.length + (page - 1) * limit} out of {totalCount}{" "}
            items{" "}
          </div>
          <div
            className="di-flex"
            style={{ justifyContent: "end", gap: "10px" }}
          >
            <button
              disabled={page == 1}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity: page == 1 ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (p > 1 ? p - 1 : p))}
            >
              Previous
            </button>
            <button
              disabled={students.length + (page - 1) * limit >= totalCount}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity:
                  students.length + (page - 1) * limit >= totalCount ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (students.length ? p + 1 : p))}
            >
              Next
            </button>
          </div>
        </div>
          </div>
        </div>
        
       
      
       
      
        
      </div>

      
    </div>
  );
};

export default ReportHistoryDetails;
